import { Box, List, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { UserCircleIcon } from '~components/icons'
import useBreakpoint from '~hooks/use-breakpoint'
import {
  breakpointsWithHamburgerMenu,
  useNavigation,
} from '../../navigation-context'
import { MenuItemTooltip } from './menu-item-tooltip'
import { MenuItemWithIcon } from './menu-item-with-icon'
import { NestedMenuItemWithIcon } from './nested-menu-item-with-icon'

export interface ChildHeader {
  title: string
  link: string
  variant?: 'primary' | 'secondary'
  isExternal?: boolean
  className?: string
}

export interface NavItem extends ChildHeader {
  children?: ChildHeader[]
  icon?: ReactNode
}

export function MenuItemsRenderer({
  topItems,
  bottomItems,
}: {
  topItems?: NavItem[]
  bottomItems?: NavItem[]
}) {
  const { isOpen: isMenuOpen } = useNavigation()
  const { breakpoint } = useBreakpoint()
  const isHamburger = breakpointsWithHamburgerMenu.includes(breakpoint)

  return (
    <Box
      sx={{
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: isHamburger ? 'auto' : '100vh',
        pb: isHamburger ? 10 : 0,
      }}
    >
      <List>
        {topItems?.map((item) =>
          item.children ? (
            <NestedMenuItemWithIcon
              parent={item.title}
              menuItemChildren={item.children.map((child) => ({
                label: child.title,
                link: child.link,
              }))}
              key={item.title}
              icon={item.icon}
              className={item.className}
            />
          ) : (
            <MenuItemWithIcon
              key={item.title}
              label={item.title}
              link={item.link}
              icon={item.icon}
              className={item.className}
            />
          ),
        )}
      </List>
      <List>
        {bottomItems && (
          <>
            {isMenuOpen && bottomItems.length > 0 && (
              <Typography variant="label" sx={{ pl: 3 }}>
                Other
              </Typography>
            )}
            {bottomItems?.map((item) =>
              item.children ? (
                <NestedMenuItemWithIcon
                  tooltipTitle={item.title}
                  parent={isMenuOpen ? item.title : ''}
                  menuItemChildren={item.children.map((child) => ({
                    label: child.title,
                    link: child.link,
                  }))}
                  key={item.title}
                  icon={item.icon}
                />
              ) : (
                <MenuItemTooltip key={item.title} title={item.title}>
                  <MenuItemWithIcon
                    label={isMenuOpen ? item.title : ''}
                    link={item.link}
                    icon={item.icon}
                    className={item.className}
                  />
                </MenuItemTooltip>
              ),
            )}
            <MenuItemTooltip title="Profile">
              <MenuItemWithIcon
                label={!isMenuOpen ? '' : 'Profile'}
                link="/profile"
                icon={<UserCircleIcon />}
                withIconInCircle
              />
            </MenuItemTooltip>
          </>
        )}
      </List>
    </Box>
  )
}
